/* ══════════════════════════════════════════════════════════════════
   LES SIX FEUILLES DE L'ACCUEIL — transcription de
   docs/handoff/feuilles-accueil.jsx (qui FAIT FOI sur le dessin),
   complétée par les ÉTATS DYNAMIQUES d'admin-proto.html que l'extrait
   statique ne portait pas (classes `on`/`occ`, intérieurs des coches,
   écran de refus fAccRefusHoraire, raison de la reprise) — valeurs et
   styles repris de ses fonctions choix()/coche()/ligneAuto()/saisieM().

   ⚠️ AUCUNE taille, couleur ni espacement inventé ici. Les données
   d'exemple (marquées DONNÉE dans le fichier source) arrivent en
   props ; les gestes arrivent en props on… ; les classes viennent de
   src/styles/fbz-admin.css (copie de docs/handoff/fbz-admin.css).

   La CAUTION du jugement est montée INACTIVE avec sa raison écrite
   (consigne du 26/08) : l'encaissement Stripe n'est pas branché.
   ══════════════════════════════════════════════════════════════════ */

import React from 'react'

/* Les tons de coche/choix — TONS d'admin-proto.html, tels quels. */
const TONS = {
  terra: ['#f7ddd4', '#d19782', 'var(--terra)', '#fff', 'var(--terra-tx)'],
  ambre: ['#faeacb', '#cfa758', 'var(--ambre)', '#fff', 'var(--ambre-tx)'],
  ciel: ['#d6e8f7', '#8fb6d6', 'var(--navy)', '#fff', 'var(--navy-d)'],
  gris: ['#eaeff4', '#c3cdd6', '#5c6773', '#fff', '#3d4a57'],
  vert: ['#d7ece1', '#9ccbb2', '#4a9d7a', '#fff', '#124a33'],
}

const svgCoche = (c) => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="3"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
)

/* La pastille d'agent du proto — .ag/.av/.agTx, états on/occ/moi. */
export function PastilleAg({ ini, nom, charge, occupe, moi, on, tagOccupe, onClic, testId }) {
  return (
    <button type="button" data-testid={testId}
      className={`ag${on ? ' on' : ''}${occupe ? ' occ' : ''}${moi ? ' moi' : ''}`}
      onClick={onClic}>
      <span className="av">{ini}</span>
      <span className="agTx"><b>{nom}</b><i>{charge}</i></span>
      {occupe && tagOccupe && <span className="tag t-a">{tagOccupe}</span>}
    </button>
  )
}

/* choix() du proto — radio 52 px, sélection = anneau 6 px + bord 2 px du ton. */
export function ChoixRadio({ options, sel, onSel, dans, testIdPrefix }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: dans ? '6px' : '7px' }}>
      {options.map((x) => {
        const on = sel === x.id
        const k = TONS[x.ton] || TONS.gris
        return (
          <button key={x.id} type="button" data-testid={`${testIdPrefix}-${x.id}`}
            onClick={() => onSel(x.id)}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
              textAlign: 'left',
              border: on ? `2px solid ${k[2]}` : `1px solid ${dans ? 'rgba(255,255,255,.9)' : 'var(--bord)'}`,
              borderRadius: '11px', padding: on ? '8px 10px' : '9px 11px',
              background: '#fff', minHeight: dans ? '46px' : '52px' }}>
            <span style={{ width: '20px', height: '20px', borderRadius: '50%',
              border: on ? `6px solid ${k[2]}` : '1.5px solid #c3cdd6', flexShrink: 0 }} />
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: 'block', fontSize: '12.5px', fontWeight: 600,
                color: on ? k[4] : 'var(--navy-d)' }}>{x.titre}</span>
              <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
                marginTop: '1px' }}>{x.sous}</span>
            </span>
          </button>
        )
      })}
    </div>
  )
}

/* coche() du proto — case 52 px, cochée = cadre 2 px + fond du ton + intérieur. */
export function Coche({ v, titre, sous, onBasc, ton = 'ciel', dedans, desactive, testId }) {
  const k = TONS[ton] || TONS.ciel
  const tete = (
    <button type="button" data-testid={testId} onClick={desactive ? undefined : onBasc}
      disabled={desactive}
      style={{ display: 'flex', alignItems: 'center', gap: '11px', width: '100%',
        textAlign: 'left', padding: '10px 12px', minHeight: '52px', background: 'none',
        border: 'none', opacity: desactive ? 0.45 : 1,
        cursor: desactive ? 'default' : 'pointer' }}>
      <span style={{ width: '20px', height: '20px', borderRadius: '6px',
        ...(v ? { border: 'none', background: k[2] } : { border: '1.5px solid #c3cdd6' }),
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {v ? svgCoche('#fff') : null}
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: '12.5px', fontWeight: 600,
          color: v ? k[4] : 'var(--navy-d)' }}>{titre}</span>
        <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
          marginTop: '1px' }}>{sous}</span>
      </span>
    </button>
  )
  if (!v) {
    return (
      <div style={{ border: '1px solid var(--bord)', background: '#fff',
        borderRadius: '12px', marginBottom: '7px' }}>{tete}</div>
    )
  }
  return (
    <div style={{ border: `2px solid ${k[2]}`, background: k[0], borderRadius: '12px',
      marginBottom: '7px', overflow: 'hidden' }}>
      {tete}
      {dedans ? <div style={{ padding: '0 12px 12px 43px' }}>{dedans}</div> : null}
    </div>
  )
}

/* saisieM() du proto — la ligne de montant, avertissement optionnel. */
export function SaisieMontant({ label, avert, valeur, onChange, testId }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '7px 11px',
      background: '#fff', border: '1px solid var(--bord)', borderRadius: '10px' }}>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: '11.5px', color: 'var(--gris)' }}>{label}</span>
        {avert && (
          <span style={{ display: 'block', fontSize: '9.5px', color: 'var(--terra-tx)' }}>{avert}</span>
        )}
      </span>
      <span style={{ display: 'flex', alignItems: 'center', gap: '4px', background: '#f8fafc',
        border: '1px solid #d5e3ee', borderRadius: '9px', padding: '0 10px 0 4px' }}>
        <input type="text" inputMode="decimal" data-testid={testId} value={valeur}
          onChange={(e) => onChange(e.target.value)} onFocus={(e) => e.target.select()}
          style={{ width: '62px', height: '40px', border: 'none', background: 'none',
            fontSize: '14px', fontWeight: 600, textAlign: 'right', color: 'var(--navy-d)',
            fontFamily: 'inherit', outline: 'none' }} />
        <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--gris)' }}>€</span>
      </span>
    </div>
  )
}

/* ═══ 1 · UN MÉNAGE SANS AGENT ═════════════════════════════════════ */
export function FeuilleMenageSansAgent({ sousTitre, departLb = 'Départ du voyageur',
  departH, departPlein, arriveeH, arriveePleine, dureeTxt, agents = [], moi,
  choisi, onChoisir, onConfier, onAnnuler, erreur }) {
  const elu = agents.find((a) => a.id === choisi) || (moi && choisi === moi.id ? moi : null)
  return (
    <>
      <p className="fSous">{sousTitre}</p>
      <div className="hDuo">
        <div className={`hCase ${departPlein ? 'pleine' : 'vide'}`}>
          <span className="hLb">{departLb}</span>
          <span className="hVal">{departH}</span>
        </div>
        <div className={`hCase ${arriveePleine ? 'pleine' : 'vide'}`}>
          <span className="hLb">Arrivée du suivant</span>
          <span className="hVal">{arriveeH}</span>
        </div>
      </div>
      {dureeTxt && <p className="note">Durée prévue : {dureeTxt}.</p>}
      <p className="inter">Qui prend ce ménage ?</p>
      <div className="pastilles">
        {agents.map((a) => (
          <PastilleAg key={a.id} testId={`designer-agent-${a.id}`} ini={a.ini} nom={a.nom}
            charge={a.charge} occupe={a.occupe} tagOccupe={a.tagOccupe}
            on={choisi === a.id} onClic={() => onChoisir(a.id)} />
        ))}
        {moi && (
          <PastilleAg testId="designer-agent-moi" ini="VS" nom="Moi" charge="je m'en occupe"
            moi on={choisi === moi.id} onClic={() => onChoisir(moi.id)} />
        )}
      </div>
      <p className="note">Un agent occupé reste choisissable — la couleur informe, elle n'interdit pas.</p>
      <div className="act">
        {elu
          ? <button className="bt bt-p" data-testid="confier-menage"
              onClick={onConfier}>Confier à {elu.nom}</button>
          : <span className="bt bt-p off" data-testid="confier-menage-off">Confier</span>}
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      {erreur}
    </>
  )
}


/* La FRISE de la demande d'horaire — friseHor() d'admin-proto, transcrite
   telle quelle : le séjour en gris-bleu plein qui suit le curseur, ce qu'il
   réclame au-delà en hachures, le bloc ménage (bleu quand il tient, rose
   bordé de rouge sinon), le repère du contrat et ses trois étiquettes. */
export function FriseHoraire({ contratH, finH, demandeH, dureeH, h, ok,
  voyageurLabel, hFmt, contratLabel, finLabel }) {
  const tot = finH - contratH
  if (!(tot > 0)) return null
  const pct = (x) => Math.max(0, Math.min(100, ((x - contratH) / tot) * 100))
  const largeurMen = dureeH ? (dureeH / tot) * 100 : 0
  return (
    <div className="carte" style={{ margin: '0 0 9px' }} data-testid="horaire-frise">
      <div style={{ position: 'relative', height: '36px', background: '#f6f8fa',
        borderRadius: '7px' }}>
        <span style={{ position: 'absolute', inset: '0', background: '#fff',
          border: '1px solid #dbe3ea', borderRadius: '7px' }} />
        {/* le séjour du voyageur, prolongé jusqu'à l'heure choisie */}
        <span style={{ position: 'absolute', left: '0', width: `${pct(h)}%`, top: '0',
          height: '100%', background: '#3d5166', borderRadius: '7px 4px 4px 7px',
          display: 'flex', alignItems: 'center', padding: '0 8px', overflow: 'hidden' }}>
          <span style={{ flex: '1', minWidth: '0', fontSize: '9.5px', color: '#fff',
            fontWeight: '600', whiteSpace: 'nowrap',
            overflow: 'hidden' }}>{voyageurLabel}</span>
          <span style={{ fontSize: '9.5px', color: '#fff', fontWeight: '600',
            whiteSpace: 'nowrap' }}>{hFmt(h)}</span>
        </span>
        {/* ce qu'il réclame au-delà, en hachures */}
        {h < demandeH && (
          <span data-testid="horaire-frise-hachures" style={{ position: 'absolute',
            left: `${pct(h)}%`, width: `${pct(demandeH) - pct(h)}%`, top: '0',
            height: '100%',
            background: 'repeating-linear-gradient(45deg,rgba(61,81,102,.5) 0 5px,rgba(61,81,102,.16) 5px 10px)' }} />
        )}
        {/* le bloc de ménage */}
        {largeurMen > 0 && (
          <span data-testid={ok ? 'horaire-frise-menage' : 'horaire-frise-menage-ko'}
            style={{ position: 'absolute', left: `${pct(h)}%`, width: `${largeurMen}%`,
              top: '0', height: '100%', background: ok ? '#5c8ab8' : '#f0c4b6',
              border: `1px solid ${ok ? '#5c8ab8' : '#b8412b'}`, borderRadius: '4px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              overflow: 'hidden' }}>
            <span style={{ fontSize: '9.5px', color: ok ? '#fff' : '#8f2f1d',
              fontWeight: '600', whiteSpace: 'nowrap' }}>ménage</span>
          </span>
        )}
        {/* le repère du contrat */}
        <span style={{ position: 'absolute', left: '0', top: '-2px', height: '40px',
          width: '2px', background: '#8b96a3', zIndex: '5' }} />
        <span style={{ position: 'absolute', left: '-5.5px', top: '-7px', width: '13px',
          height: '13px', borderRadius: '50%', background: '#8b96a3', zIndex: '5' }} />
      </div>
      <div style={{ position: 'relative', height: '14px', marginTop: '5px' }}>
        <span style={{ position: 'absolute', left: '0', fontSize: '9.5px',
          color: 'var(--gris-d)' }}>{contratLabel}</span>
        <span style={{ position: 'absolute', left: `${pct(demandeH)}%`,
          transform: 'translateX(-50%)', fontSize: '9.5px', color: '#3d5166',
          fontWeight: '600' }}>demandé</span>
        <span style={{ position: 'absolute', right: '0', fontSize: '9.5px',
          color: 'var(--gris-d)' }}>{finLabel}</span>
      </div>
    </div>
  )
}

/* ═══ 2 · UNE DEMANDE D'HORAIRE ════════════════════════════════════ */
export function FeuilleDemandeHoraire({ sousTitre, heroLb, heroVal, heroKo,
  frise, contratH, arriveeH, arriveePleine, min, max, valeur, onGlisse, chips = [],
  recapTitre, recapPhrase, noteKo, accorderLb, accorderActif, onAccorder,
  onRefuser, erreur }) {
  return (
    <>
      <p className="fSous">{sousTitre}</p>
      <div className={`hero${heroKo ? ' hero-ko' : ''}`} data-testid="horaire-hero">
        <span className="heroLb">{heroLb}</span>
        <span className="heroVal">{heroVal}</span>
      </div>
      <div className="hDuo">
        <div className="hCase pleine">
          <span className="hLb">Au contrat</span>
          <span className="hVal">{contratH}</span>
        </div>
        <div className={`hCase ${arriveePleine ? 'pleine' : 'vide'}`}>
          <span className="hLb">Arrivée du suivant</span>
          <span className="hVal">{arriveeH}</span>
        </div>
      </div>
      <p className="inter">L'heure de départ</p>
      {frise && <FriseHoraire {...frise} />}
      <input type="range" min={min} max={max} step={0.5} value={valeur}
        data-testid="horaire-curseur"
        onChange={(e) => onGlisse(parseFloat(e.target.value))} className="curs" />
      <div className="chips">
        {chips.map((c) => (
          <button key={c.h} type="button" data-testid={`horaire-chip-${c.h}`}
            className={`chip${valeur === c.h ? ' on' : ''}`}
            onClick={() => onGlisse(c.h)}>{c.label}</button>
        ))}
      </div>
      <div className="carte" style={{ margin: '11px 0 0', background: 'var(--ciel-p)',
        borderColor: '#c3d5e4' }}>
        <p style={{ fontSize: '13px', fontWeight: 600, margin: 0,
          color: 'var(--navy-d)' }}>{recapTitre}</p>
        <p data-testid="horaire-montant" style={{ fontSize: '11.5px', margin: '4px 0 0',
          color: 'var(--navy-d)', lineHeight: 1.55 }}>{recapPhrase}</p>
        {noteKo && <p className="note" style={{ color: 'var(--terra-tx)' }}>{noteKo}</p>}
      </div>
      <div className="act">
        {accorderActif
          ? <button className="bt bt-p" data-testid="horaire-accorder"
              onClick={onAccorder}>{accorderLb}</button>
          : <span className="bt bt-p off" data-testid="horaire-accorder-off">{accorderLb}</span>}
        <button className="bt bt-s" data-testid="horaire-refuser" onClick={onRefuser}>Refuser</button>
      </div>
      {erreur}
    </>
  )
}

/* L'écran de refus — fAccRefusHoraire d'admin-proto, tel quel. */
export function FeuilleRefusHoraire({ nom, contratH, raisonRef, onConfirmer, onRevenir, erreur }) {
  return (
    <>
      <div className="warn">{nom} gardera son horaire de contrat, <b>{contratH}</b>.
        {' '}Il sera prévenu du refus.</div>
      <div className="carte" style={{ margin: 0 }}>
        <span style={{ display: 'block', fontSize: '11.5px', color: 'var(--gris)',
          marginBottom: '6px' }}>Une raison, si vous voulez</span>
        <div contentEditable="true" className="champ" data-testid="horaire-raison"
          ref={raisonRef} suppressContentEditableWarning />
        <p className="note">Elle la recevra telle quelle.</p>
      </div>
      <div className="act">
        <button className="bt bt-p" data-testid="horaire-confirmer-refuser"
          onClick={onConfirmer}>Refuser et prévenir</button>
        <button className="bt bt-s" onClick={onRevenir}>Revenir</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ 3 · UN INCIDENT À TRANCHER — le jugement complet ═════════════ */
export function FeuilleJugement({ preliminaire, article, sousJuge, montant,
  onMontant, habituel, sousLoc, jR, onJugR, jRien, onJRien, cautionRaison,
  jAcOn, onJAcOn, acEtat, onAcEtat, acMontant, onAcMontant, jRef, onJRef,
  refacForce, refacSous, bilan = [], pret, enregistrerLb = 'Enregistrer',
  onEnregistrer, onAnnuler, erreur }) {
  // `preliminaire` (état « À vérifier », arbitrage 2026-08-27) : l'article
  // n'a pas encore été jugé — l'admin le juge ICI, avec les MÊMES briques
  // (en-tête de section + ChoixRadio du proto). Le fichier livré ne couvrait
  // pas cet état : section ADDITIVE, rien du balisage existant ne bouge.
  const masqueArgent = preliminaire && preliminaire.verdict !== 'nonrecup'
  return (
    <>
      <div style={{ background: '#87b8e6', borderRadius: '14px', padding: '12px 13px',
        position: 'relative', overflow: 'hidden' }}>
        <span style={{ position: 'absolute', top: '-30px', right: '-18px', width: '88px',
          height: '88px', borderRadius: '50%', background: 'rgba(255,255,255,.12)' }} />
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center',
          gap: '9px', marginBottom: '10px' }}>
          <span style={{ width: '30px', height: '30px', borderRadius: '8px',
            background: 'rgba(255,255,255,.22)', color: '#fff', display: 'flex',
            alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 11l3 3L22 4" />
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
            </svg>
          </span>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span data-testid="incident-article" style={{ display: 'block', fontSize: '14px',
              fontWeight: 600, color: '#fff' }}>{article}</span>
            <span style={{ display: 'block', fontSize: '10.5px',
              color: 'rgba(255,255,255,.78)', marginTop: '1px' }}>{sousJuge}</span>
          </span>
        </div>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '9px',
          background: 'rgba(255,255,255,.16)', borderRadius: '11px', padding: '7px 11px' }}>
          <span style={{ flex: 1, minWidth: 0 }}>
            <span style={{ display: 'block', fontSize: '11.5px', color: '#fff',
              fontWeight: 500 }}>Prix du remplacement</span>
            <span data-testid="incident-habituellement" style={{ display: 'block',
              fontSize: '9.5px', color: 'rgba(255,255,255,.72)' }}>{habituel}</span>
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px', background: '#fff',
            borderRadius: '9px', padding: '0 10px 0 4px' }}>
            <input type="text" inputMode="decimal" data-testid="incident-montant"
              value={montant} onChange={(e) => onMontant(e.target.value)}
              onFocus={(e) => e.target.select()}
              style={{ width: '60px', height: '38px', border: 'none', background: 'none',
                fontSize: '14px', fontWeight: 600, textAlign: 'right',
                color: 'var(--navy-d)', fontFamily: 'inherit', outline: 'none' }} />
            <span style={{ fontSize: '13px', fontWeight: 600, color: 'var(--gris)' }}>€</span>
          </span>
        </div>
      </div>
      {preliminaire ? (
        <>
          <p className="note">Déclaré par l'agent, pas encore jugé — à vous de dire s'il est récupérable.</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 9px' }}>
            <span style={{ width: '24px', height: '24px', borderRadius: '7px',
              background: 'var(--ambre)', color: '#fff', display: 'flex',
              alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M9 11l3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
              </svg>
            </span>
            <span style={{ fontSize: '11.5px', fontWeight: 600,
              color: 'var(--ambre-tx)' }}>L'article est-il récupérable ?</span>
          </div>
          <ChoixRadio testIdPrefix="incident-verdict" sel={preliminaire.verdict}
            onSel={preliminaire.onVerdict}
            options={[
              { id: 'recup', titre: 'Récupérable',
                sous: "un lavage ou une réparation suffit — l'affaire s'arrête là", ton: 'vert' },
              { id: 'nonrecup', titre: 'Non récupérable',
                sous: 'il faudra remplacer — vous déciderez qui paie', ton: 'terra' },
            ]} />
        </>
      ) : (
        <p className="note">L'orchestrateur a jugé. Il ne voit aucun montant : c'est à vous de décider qui paie.</p>
      )}

      {!masqueArgent && (<>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 9px' }}>
        <span style={{ width: '24px', height: '24px', borderRadius: '7px',
          background: 'var(--ambre)', color: '#fff', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </span>
        <span style={{ fontSize: '11.5px', fontWeight: 600,
          color: 'var(--ambre-tx)' }}>Qui rachète l'article</span>
      </div>
      <ChoixRadio testIdPrefix="incident-rachete" sel={jR} onSel={onJugR}
        options={[
          ...(sousLoc ? [] : [{ id: 'proprio', titre: 'Le propriétaire rachète',
            sous: "il s'en occupe lui-même", ton: 'ambre' }]),
          { id: 'nous', titre: 'Nous rachetons', sous: 'nous avançons le remplacement', ton: 'ciel' },
        ]} />
      {sousLoc && (
        <p className="note">Vous êtes l'hôte de ce logement — il n'y a personne à qui refacturer.</p>
      )}

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 9px' }}>
        <span style={{ width: '24px', height: '24px', borderRadius: '7px',
          background: '#4a9d7a', color: '#fff', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M4 10h12M4 14h9" />
            <path d="M19 5a7 7 0 1 0 0 14" />
          </svg>
        </span>
        <span style={{ fontSize: '11.5px', fontWeight: 600,
          color: 'var(--vert-tx)' }}>Comment c'est payé</span>
      </div>
      <p className="note" style={{ margin: '-4px 0 9px' }}>
        Un seul choix. La caution et AirCover s'excluent : AirCover remplace la caution sur Airbnb.
      </p>
      <Coche testId="incident-rien" v={jRien} onBasc={onJRien} ton="gris"
        titre={jR === 'proprio' ? 'Rien à récupérer' : 'À notre charge, rien à récupérer'}
        sous={jR === 'proprio' ? "il rachète, l'affaire s'arrête là"
          : `nous payons ${montant || '—'} € sans les refacturer`} />
      <Coche testId="incident-caution" v={false} desactive ton="terra"
        titre="Encaissé sur la caution du voyageur"
        sous={cautionRaison} />
      <Coche testId="incident-aircover" v={jAcOn} onBasc={onJAcOn} ton="ciel"
        titre="Une demande AirCover est ouverte"
        sous="sur Airbnb uniquement — remplace la caution"
        dedans={jAcOn ? (
          <>
            <ChoixRadio dans testIdPrefix="incident-ac" sel={acEtat} onSel={onAcEtat}
              options={[
                { id: 'attente', titre: 'En attente de réponse',
                  sous: "Airbnb n'a pas encore répondu", ton: 'ambre' },
                { id: 'rembourse', titre: 'Airbnb a remboursé',
                  sous: 'saisissez le montant reçu', ton: 'vert' },
                { id: 'refuse', titre: 'Airbnb a refusé', sous: "rien n'est couvert", ton: 'terra' },
              ]} />
            {acEtat === 'rembourse' && (
              <>
                <div style={{ height: '7px' }} />
                <SaisieMontant testId="incident-ac-montant" label="Montant remboursé"
                  valeur={acMontant} onChange={onAcMontant} />
              </>
            )}
            {jR === 'nous' && !sousLoc && (
              <button type="button" data-testid="incident-refac-auto" onClick={onJRef}
                style={{ display: 'flex', alignItems: 'center', gap: '9px', width: '100%',
                  textAlign: 'left', background: '#fff',
                  border: `1px solid ${jRef ? TONS.ambre[1] : 'var(--bord)'}`,
                  borderRadius: '10px', padding: '8px 11px', marginTop: '7px',
                  minHeight: '46px' }}>
                <span style={{ width: '18px', height: '18px', borderRadius: '5px',
                  ...(jRef ? { border: 'none', background: TONS.ambre[2] }
                    : { border: '1.5px solid #c3cdd6' }),
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0 }}>{jRef ? svgCoche('#fff') : null}</span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: '11.5px', fontWeight: 600,
                    color: jRef ? TONS.ambre[4] : 'var(--gris)' }}>Refacturé au propriétaire</span>
                  <span style={{ display: 'block', fontSize: '9.5px', color: 'var(--gris)' }}>
                    {jRef ? refacSous : 'décoché — la dépense reste à notre charge'}</span>
                </span>
              </button>
            )}
            {acEtat === 'attente' && (
              <p className="note" style={{ margin: '7px 0 0' }}>
                Tant qu'Airbnb n'a pas répondu, cet incident reste sur votre accueil.</p>
            )}
          </>
        ) : null} />
      {jR === 'nous' && !refacForce && !sousLoc && (
        <Coche testId="incident-refac" v={jRef} onBasc={onJRef} ton="ambre"
          titre="Refacturé au propriétaire" sous={refacSous} />
      )}
      </>)}
      {masqueArgent ? null : bilan.length === 0
        ? <p className="note">Tant que le rachat n'est pas renseigné, l'incident n'entre dans aucun compte.</p>
        : bilan.map((l, i) => <p key={i} className="note" data-testid="incident-bilan">{l}</p>)}
      <div className="act">
        {pret
          ? <button className="bt bt-p" data-testid="incident-valider"
              onClick={onEnregistrer}>{enregistrerLb}</button>
          : <span className="bt bt-p off" data-testid="incident-valider-off">{enregistrerLb}</span>}
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ 4 · LE SUIVI : rachat, dépôt, réponse AirCover ═══════════════ */
export function FeuilleSuivi({ recap, echeance, echeanceTon, etatTitre, etatTon = 'ambre',
  rachete, depose, onOuvrirRachete, onOuvrirDepose, calendrier, etatPhrase, etatClos,
  onEnregistrer, enregistrerActif, onRevoir, erreur }) {
  return (
    <>
      {echeance && (
        <div className={`ech${echeanceTon === 'terra' ? ' ko' : ''}`}
          data-testid="aircover-echeance">{echeance}</div>
      )}
      <div className="info">{recap}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 9px' }}>
        <span style={{ width: '24px', height: '24px', borderRadius: '7px',
          background: etatClos ? '#4a9d7a' : 'var(--ambre)', color: '#fff', display: 'flex',
          alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </span>
        <span style={{ fontSize: '11.5px', fontWeight: 600,
          color: etatClos ? 'var(--vert-tx)' : 'var(--ambre-tx)' }}>{etatTitre}</span>
      </div>
      <div style={{ display: 'flex', gap: '7px' }}>
        <button type="button" data-testid="aircover-rachete" onClick={onOuvrirRachete}
          style={{ flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'flex-start', gap: '1px', padding: '7px 11px', borderRadius: '10px',
            border: rachete ? '1px solid var(--bord)' : '1px dashed #c3d5e4',
            background: rachete ? '#fff' : '#f8fafc', minHeight: '44px' }}>
          <span style={{ fontSize: '9.5px', color: 'var(--gris)' }}>Racheté le</span>
          <span style={{ fontSize: '12px', fontWeight: 600,
            color: rachete ? 'var(--navy-d)' : 'var(--gris-d)' }}>{rachete || 'à saisir'}</span>
        </button>
        <button type="button" data-testid="aircover-depose" onClick={onOuvrirDepose}
          style={{ flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'flex-start', gap: '1px', padding: '7px 11px', borderRadius: '10px',
            border: depose ? '1px solid var(--bord)' : '1px dashed #c3d5e4',
            background: depose ? '#fff' : '#f8fafc', minHeight: '44px' }}>
          <span style={{ fontSize: '9.5px', color: 'var(--gris)' }}>Déposé le</span>
          <span style={{ fontSize: '12px', fontWeight: 600,
            color: depose ? 'var(--navy-d)' : 'var(--gris-d)' }}>{depose || 'à saisir'}</span>
        </button>
      </div>
      {calendrier}
      <div className="carte" style={{ margin: '12px 0 0',
        background: etatClos ? 'var(--vert-bg)' : 'var(--ambre-bg)',
        borderColor: etatClos ? 'var(--vert-bd)' : 'var(--ambre-bd)' }}>
        <p data-testid="aircover-etat" style={{ fontSize: '12.5px', margin: 0,
          lineHeight: 1.6,
          color: etatClos ? 'var(--vert-tx)' : 'var(--ambre-tx)' }}>{etatPhrase}</p>
      </div>
      <div className="act">
        {enregistrerActif
          ? <button className="bt bt-p" data-testid="aircover-enregistrer"
              onClick={onEnregistrer}>Enregistrer</button>
          : <span className="bt bt-p off">Enregistrer</span>}
        <button className="bt bt-s" data-testid="aircover-revoir"
          onClick={onRevoir}>Revoir le jugement</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ 5 · UNE REPRISE EN ATTENTE ═══════════════════════════════════ */
export function FeuilleReprise({ sousTitre, points = [], anonymat, choix, onChoix,
  raisonRef, pret, onValider, onAnnuler, erreur }) {
  return (
    <>
      <p className="fSous">{sousTitre}</p>
      <div className="ctBloc">
        <p className="ctT">Des points à reprendre</p>
        {points.map((pt, i) => (
          <div className="ctPt" key={i}>
            <span className="ctPtT">{pt.titre}</span>
            <span className="ctPtS">{pt.sous}</span>
            {pt.photo && (
              <span className="ctPh" style={pt.photo !== true
                ? { backgroundImage: `url(${pt.photo})`, backgroundSize: 'cover',
                    backgroundPosition: 'center' } : undefined} />
            )}
          </div>
        ))}
        {anonymat && <p className="ctA">{anonymat}</p>}
      </div>
      <p className="inter">Que faites-vous ?</p>
      <div className="choix">
        <button className={`ch3${choix === 'moi' ? ' on' : ''}`} data-testid="reprise-je-repasse"
          onClick={() => onChoix('moi')}>
          <b>Je repasse moi-même</b><i>une tâche naîtra dans Mes tâches</i>
        </button>
        <button className={`ch3${choix === 'agent' ? ' on' : ''}`} data-testid="reprise-renvoyer-agent"
          onClick={() => onChoix('agent')}>
          <b>Je renvoie l'agent</b><i>il repassera sur ses points</i>
        </button>
        <button className={`ch3${choix === 'ok' ? ' on' : ''}`} data-testid="reprise-cest-bon"
          onClick={() => onChoix('ok')}>
          <b>Finalement c'est bon</b><i>la reprise est levée</i>
        </button>
      </div>
      {choix === 'ok' && (
        <div className="carte" style={{ margin: '11px 0 0' }}>
          <span style={{ display: 'block', fontSize: '11.5px', color: 'var(--gris)',
            marginBottom: '6px' }}>Pourquoi (obligatoire)</span>
          <div contentEditable="true" className="champ" data-testid="reprise-raison"
            ref={raisonRef} suppressContentEditableWarning />
          <p className="note">On doit savoir pourquoi une reprise a été annulée.</p>
        </div>
      )}
      <div className="act">
        {pret
          ? <button className="bt bt-p" data-testid="reprise-valider" onClick={onValider}>Valider</button>
          : <span className="bt bt-p off" data-testid="reprise-valider-off">Valider</span>}
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ 6 · UN CONTRÔLE SANS PERSONNE ════════════════════════════════ */
export function FeuilleControleSansPersonne({ sousTitre, faitPar, agents = [], choisi,
  onChoisir, exclusion, onConfier, onAnnuler, onMoiMeme, erreur }) {
  const elu = agents.find((a) => a.id === choisi) || null
  return (
    <>
      <p className="fSous">{sousTitre}</p>
      <div className="carte" style={{ margin: 0, background: 'var(--vert-bg)',
        borderColor: 'var(--vert-bd)' }}>
        <p data-testid="feuille-rappel-fait" style={{ fontSize: '12px', fontWeight: 600,
          margin: 0, color: 'var(--vert-tx)' }}>{faitPar}</p>
      </div>
      <p className="inter">Qui contrôle ce ménage ?</p>
      <div className="pastilles">
        {agents.map((a) => (
          <PastilleAg key={a.id} testId={`confier-controle-${a.id}`} ini={a.ini} nom={a.nom}
            charge={a.charge} on={choisi === a.id} onClic={() => onChoisir(a.id)} />
        ))}
      </div>
      {exclusion && <p className="note">{exclusion}</p>}
      <div className="act">
        {elu
          ? <button className="bt bt-p" data-testid="confier-controleur"
              onClick={onConfier}>Confier à {elu.nom}</button>
          : <span className="bt bt-p off">Confier</span>}
        <button className="bt bt-s" onClick={onAnnuler}>Annuler</button>
      </div>
      <div className="moiBloc">
        <p className="moiT">Vous n'êtes pas dans la liste</p>
        <p className="moiS">Vous contrôlez quand vous voulez, sans être désigné.</p>
        <button className="bt bt-p" data-testid="controler-moi-meme"
          onClick={onMoiMeme}>Je contrôle maintenant</button>
      </div>
      {erreur}
    </>
  )
}
